import { useSearchInput } from '../hooks'

const SearchInput = ({ mapId }) => {
  const [{ query, isSearching }, { onChange, onKeyDown, start, clear }] = useSearchInput(mapId)

  return (
    <div className="map--search">
      <input className="map--search-field" type="search" placeholder="search" value={query} onChange={onChange} onKeyDown={onKeyDown} />
      <button className="search--icon" onClick={start}><img src="images/search-icon.svg" alt="search-icon" /></button>
      <button className="search--cancel" onClick={clear}><img src="images/x-icon.svg" alt="x-icon" /></button>
    </div>
  )
}

export default SearchInput